module.exports = __webpack_public_path__ + "media/images/qr/illustrated-qr-colour-ea45086c3b15c542757fbb6591d15e5a.svg";